<template>
    <div class="content_box">
        <div class="content sales-operation" ref="sales-operation" id="sales-operation">
			<div class="search_box">
				<div class="title title_flex">
					<span>销售总览</span>
					<el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                        <div class="tip" slot="content">
                            <p>1. 目前仅接入亚马逊平台销售数据</p>
                            <p>2. 销量/销售额，实时查询当日数据需12点（UTC时间凌晨4点）之后，每小时更新一次</p>
                            <p>3. 总成本/毛利润为估算数据，且有一定滞后性，每月5号统计上月数据后较为准确</p>
                            <p>4. 环比计算规则：（当前所选时间周期数值-上一周期的数值）/上一周期的数值</p>
                        </div>
                        <img class="icon-tip" v-if="$store.state.type == 'pc'" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                    </el-tooltip>
					<i class="el-icon-full-screen fullscreen" :title="isFullscreen ? '取消全屏' : '全屏'" @click="fullscreen" v-if="type == 'browser'"></i>
				</div>
				<div class="search">
					<el-form :inline="true" class="demo-form-inline search-form form-list">
                        <el-form-item>
                            <el-select v-model="searchData.platform_list" multiple collapse-tags clearable :popper-append-to-body="false" @change="getParamList" placeholder="销售渠道">
                                <el-option :label="item.dictItemDesc" :value="item.dictItem"
                                    v-for="(item,i) in realityData.platform_list" :key="item.dictItemDesc + i"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.team_list" multiple collapse-tags clearable :popper-append-to-body="false" @change="getParamList" placeholder="业务团队">
                                <el-option :label="item" :value="item"
                                    v-for="(item,i) in realityData.team_list" :key="item + i"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.seller_list" multiple collapse-tags clearable :popper-append-to-body="false" @change="getParamList" placeholder="销售店铺">
                                <el-option :label="item" :value="item"
                                    v-for="(item,i) in realityData.seller_list" :key="item + i"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.country_list" multiple collapse-tags clearable :popper-append-to-body="false" @change="getParamList" placeholder="国家">
                                <el-option :label="item.chinese" :value="item.abbr"
                                    v-for="(item,i) in realityData.country_list" :key="item.english + i"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.product_cate_list" multiple collapse-tags clearable :popper-append-to-body="false" @change="getParamList" placeholder="产品大类">
								<el-option :label="item.dictItem" :value="item.id" v-for="(item, i) in realityData.product_cate_list" :key="item.dictItem + i + '123'"></el-option>
							</el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.product_type_list" collapse-tags placeholder="产品型号" :popper-append-to-body="false" @change="getParamList" clearable multiple>
								<el-option :label="item.dictItem" :value="item.id" v-for="(item, i) in realityData.product_type_list" :key="item.dictItem + i + '321'" ></el-option>
							</el-select>
                        </el-form-item>
						<el-form-item class="form_item date_picker">
                            <DatePicker :date="createTime" :disabled="datePickerDisable" @dateSelect="dateSelect"></DatePicker>
                        </el-form-item>
						<el-form-item>
                            <div class="button search" @click="search">
                                <span>查询</span>
                            </div>
                            <div class="button search white" @click="init">
                                <span>重置</span>
                            </div>
                        </el-form-item>
                    </el-form>
				</div>
			</div>
			<div class="main_content">
				<div class="area">
					<div class="sales_data">
						<el-row :gutter="10">
							<el-col :span="6" v-for="item in salesItemData" :key="item.ico">
								<div class="data_item bg" :class="typeSelect.value == item.value ? 'select' : ''" @click="typeSelect = item">
									<div class="ico">
										<img :src="require(`../../../assets/images/sales/${item.ico}.png`)" alt="">
									</div>
									<div class="number_box">
										<p class="name">{{item.name}}</p>
										<div class="number">
											<span>{{item.currency + ' ' + (saleData.sum ? formatNumber(saleData.sum[item.value] || 0) : 0)}}</span>
										</div>
										<p class="ratio">
											<el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
												<div class="tip" slot="content">
													{{ratioTime[0] + '~' + ratioTime[1]}}
												</div>
												<p class="ratio_box">
													<span>环比</span>
													<span class="ratio_num" :class="{'ratio_num_down': saleData.sum && saleData.sum[item.value + '_per'] < 0, 'ratio_num_up': saleData.sum && saleData.sum[item.value + '_per'] > 0}">{{saleData.sum && saleData.sum[item.value + '_per'] ? (saleData.sum[item.value + '_per'] + '%' || '--') : '--'}}</span>
													<img class="ico" v-if="saleData.sum && saleData.sum[item.value + '_per'] < 0" src="../../../assets/images/ico/down.png" alt="">
													<img class="ico" v-if="saleData.sum && saleData.sum[item.value + '_per'] > 0" src="../../../assets/images/ico/up.png" alt="">
												</p>
											</el-tooltip>
											<span class="rate" v-if="item.name == '毛利润'">{{'毛利率 ' + (saleData.sum ? (saleData.sum.gross_profit_rate ? saleData.sum.gross_profit_rate : '--')  : '--')}}</span>
										</p>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
					<div class="chart_area">
						<div class="chart_left">
							<div class="chart_left_box">
								<div class="chart_left_1 chart_type_1 margin-b">
									<div class="chart_box">
										<div class="title subtitle">
											<span>{{typeSelect.ico == 'cost' ? '成本分类占比-' : '销售渠道占比-'}}</span>
											<span>{{typeSelect.name}}</span>
										</div>
										<div class="echarts_box" >
											<div class="channels_chart chart" ref="channels_chart"></div>
										</div>
									</div>
								</div>
								<div class="chart_left_2 chart_type_1">
									<div class="chart_box">
										<div class="title subtitle">
											<span>产品大类占比-</span>
											<span>{{typeSelect.name}}</span>
										</div>
										<div class="echarts_box" >
											<div class="product_chart chart" ref="product_chart"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="chart_center">
							<div class="chart_center_box chart_type_2">
								<div class="chart_box">
									<div class="title subtitle subtitle2">
										<span>国家分布-</span>
										<span>{{typeSelect.name}}</span>
									</div>
									<div class="echarts_box" >
										<div class="world_chart chart" ref="world_chart"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="chart_right">
							<div class="chart_right_box">
								<div class="chart_type_1 margin-b">
									<div class="chart_box">
										<div class="title subtitle subtitle2">
											<span>国家排行-</span>
											<span>{{typeSelect.name == '毛利润' ? '毛利润&毛利率' : typeSelect.name}}</span>
										</div>
										<div class="echarts_box" >
											<div class="country_ranking_chart chart" ref="country_ranking_chart"></div>
										</div>
									</div>
								</div>
								<div class="chart_type_1">
									<div class="chart_box">
										<div class="title subtitle subtitle2">
											<span>产品排行-</span>
											<span>{{typeSelect.name == '毛利润' ? '毛利润&毛利率' : typeSelect.name}}</span>
										</div>
										<div class="echarts_box" >
											<div class="product_ranking_chart chart" ref="product_ranking_chart"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="trend">
						<div class="title subtitle">
							<span>历史趋势</span>
						</div>
						<div class="filter">
							<el-form label-position="left" label-width="80px">
								<el-form-item label="统计指标">
									<div class="filter_box">
										<div class="filter_item">
											
											<div class="filter_data" :class="{select:trendData.indexOf('sale_amount') != -1}" @click="trendFilter('sale_amount')">销售额</div>
											<div class="filter_data" :class="{select:trendData.indexOf('gross_profit') != -1}" @click="trendFilter('gross_profit')">毛利润</div>
											<div class="filter_data" :class="{select:trendData.indexOf('sale_num') != -1}" @click="trendFilter('sale_num')">销量</div>
										</div>
										<div class="select_show_type">
											<el-radio-group size="small" v-model="data_type">
												<el-radio-button label="TypeDay">日</el-radio-button>
												<el-radio-button label="TypeWeek" :disabled="!(selectType > 1)">周</el-radio-button>
												<el-radio-button label="TypeMonth" :disabled="!(selectType > 2)">月</el-radio-button>
											</el-radio-group>
										</div>
									</div>
								</el-form-item>
							</el-form>
						</div>
						<div class="chart_box">
							<div class="trend_chart" ref="trend_chart"></div>
						</div>
					</div>
					<div class="trend_table">
						<div class="title subtitle">
							<span>数据明细</span>
						</div>
						<el-table
							:data="trendTableData">
							<el-table-column prop="val" label="日期" ></el-table-column>
							<el-table-column label="销量" >
								<template slot-scope="scope">
									<span>{{formatNumber(scope.row.sale_num || 0)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="销售额（¥）" >
								<template slot-scope="scope">
									<span>{{formatNumber(scope.row.sale_amount || 0)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="毛利润（¥）" >
								<template slot-scope="scope">
									<span>{{formatNumber(scope.row.gross_profit || 0)}}</span>
								</template>
							</el-table-column>
						</el-table>
						<Pagination :total="trendTable.length" :page="page" @paginationChange="initTableData"></Pagination>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
import '../../../../static/echarts/maps'
import '../../../../static/echarts/world'
import nameMap from '../../../js/nameMap'
import fs from '../../../js/fullscreen'
export default({
    name: 'sales-operation',
    data() {
        return {
			type: 'fs',
			contentWidth: null,
			resizeTimer: null,
			isFullscreen: false,
			datePickerDisable: false,
			searchData: {  //搜索数据
                start_time: '',
                end_time: '',
				platform_list: [],
				team_list: [],
				seller_list: [],
				country_list: [],
				product_cate_list: [],
				product_type_list: []
            },
			rootData: {  //原始数据
				country_list: [],
				product_cate_list: [],
				platform_list: [],
				product_type_list: []
			},
			selectData: {  //下拉数据源
				platform_list: [],
				team_list: [],
				seller_list: [],
				country_list: [],
				product_cate_list: [],
				product_type_list: []
			},
			realityData: {  //真实显示数据
				platform_list: [],
				team_list: [],
				seller_list: [],
				country_list: [],
				product_cate_list: [],
				product_type_list: []
			},
			createTime: '',
			ratioTime: '',
			salesItemData: [
				{
					ico: 'sales',
					name: '销量',
					value: 'sale_num',
					currency: ''
				},{
					ico: 'sales_m',
					name: '销售额',
					value: 'sale_amount',
					currency: '¥'
				},{
					ico: 'gross_profit',
					name: '毛利润',
					value: 'gross_profit',
					currency: '¥'
				},{
					ico: 'cost',
					name: '总成本',
					value: 'total_cost',
					currency: '¥'
				}
			],
			typeSelect: {
				ico: 'sales',
				name: '销量',
				value: 'sale_num',
				currency: ''
			},
			saleData: {},
			costData: {
				adsFee: '广告费用',
				cgPrice: '采购成本',
				operatingFee: '营销费用',
				otherFee: '	其他费用',
				promotionFee: '促销费',
				refundAmount: '退款额',
				sellingFee: '平台费',
				send_fee: '发货费',
				storageFee: '仓储费'
			},
			trendData: ['sale_num', 'sale_amount', 'gross_profit'],
			selectType: 3,
			data_type: 'TypeDay',
			trendTable: [],
			trendTableData: [],
			page_size: 10,
            page: 1,
        }
    },
    watch: {
		contentWidth: function(nW) {
			var worldChart = this.echarts.init(this.$refs.world_chart);
			var trendChart = this.echarts.init(this.$refs.trend_chart);
			worldChart.resize();
			trendChart.resize();
		},
		'searchData.product_id': function(nId, oId){
            this.searchData.product_type = '';
            this.productTypes = [];
            if(nId){
                this.getProductTypes(nId);
            }
        },
		createTime: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchData.start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
                this.searchData.end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
				this.getParamList();
            } else {
                this.searchData.start_time = '';
                this.searchData.end_time = '';
				this.selectType = 3;
				this.getParamList();
				return;
            }
			const day = Math.ceil((nTime[1] - nTime[0])/86400000);
			this.ratioTime = [this.formDate(nTime[0] - (86400000 * day), 'YYYY-MM-DD'), this.formDate(nTime[0] - 86400000, 'YYYY-MM-DD')];
			if(nTime[1] - nTime[0] < 86400000 * 7) { //选择7天内
                this.selectType = 1;
                this.data_type = 'TypeDay';
            }else if(nTime[1] - nTime[0] < 86400000 * 30) { //选择30天内
                this.selectType = 2;
                if(this.data_type == 'TypeMonth') {
                    this.data_type = 'TypeWeek';
                }
            }else{
                this.selectType = 3;
            }
			
        },
		typeSelect: function(nT) {
			this.initPie();
        	this.initBar();
			this.initWorld();
		},
		trendData: function(nT) {
			this.initBarLine();
		},
		data_type: function(nT) {
            this.getTrend();
        }
    },
    created() {
		this.getDictData();
    },
    activated() {
		if(window.h5sdk) {
			this.type = 'fs';
		}else{
			this.type = 'browser';
		}
		window.addEventListener('resize', this.onresize);
    },
	deactivated() {
		// 取消监听事件
		window.removeEventListener('resize', this.onresize);
	},
    methods: {
		onresize() {
			if(fs.checkFull()){ //退出全屏
				this.isFullscreen = true;
			}else{
				this.isFullscreen = false;
			}
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(() => {
				this.contentWidth = this.$refs['sales-operation'].offsetWidth;
			}, 200);
		},
		fullscreen() {  //飞书工作台不支持
			let element = document.getElementById('sales-operation');
			let full = fs.fullscreen(this.isFullscreen, element);
			this.datePickerDisable = full == 'full';
		},
		init() {
			this.searchData.platform_list = [];
			this.searchData.team_list = [];
			this.searchData.seller_list = [];
			this.searchData.country_list = [];
			this.searchData.product_cate_list = [];
			this.searchData.product_type_list = [];
            this.createTime = this.setDate(new Date().getDate());
        },
		getDictData() {
			let dictData = Promise.all([this.api.getDictData({}), this.api.getCountry({})]);
			dictData.then((r) => {
				this.rootData.country_list = r[1].data.country || [];
				this.rootData.platform_list = r[0].data.result['平台'] || [];
				this.rootData.product_cate_list = r[0].data.result['产品大类'] || [];
				this.rootData.product_type_list = r[0].data.result_list || [];
				this.createTime = this.setDate(new Date().getDate());
			})
		},
		getParamList() {
			this.api.getParamList(this.searchData).then(data => {
				const d = data.data.result;
				this.realityData = {  //初始化真实显示数据
					team_list: d.team_list,
					seller_list: d.seller_list,
					platform_list: [],
					country_list: [],
					product_cate_list: [],
					product_type_list: []
				};
				for(let i=0; i < this.rootData.platform_list.length; i++) {
					if(d.platform_list.indexOf(this.rootData.platform_list[i].dictItem) != -1) {
						this.realityData.platform_list.push(this.rootData.platform_list[i]);
					}
					if(this.realityData.platform_list.length == d.platform_list.length) break;
				}
				for(let i=0; i < this.rootData.product_cate_list.length; i++) {
					if(d.product_cate_list.indexOf(this.rootData.product_cate_list[i].id) != -1) {
						this.realityData.product_cate_list.push(this.rootData.product_cate_list[i]);
					}
					if(this.realityData.product_cate_list.length == d.product_cate_list.length) break;
				}
				for(let i=0; i < this.rootData.product_type_list.length; i++) {
					if(d.product_type_list.indexOf(this.rootData.product_type_list[i].id) != -1) {
						this.realityData.product_type_list.push(this.rootData.product_type_list[i]);
					}
					if(this.realityData.product_type_list.length == d.product_type_list.length) break;
				}
				for(let i=0; i < this.rootData.country_list.length; i++) {
					if(d.country_list.indexOf(this.rootData.country_list[i].abbr) != -1) {
						this.realityData.country_list.push(this.rootData.country_list[i]);
					}
					if(this.realityData.country_list.length == d.country_list.length) break;
				}
				if(Object.keys(this.saleData).length == 0) {
					this.getSaleOverview();
				}
			})
		},
		dateSelect(date) {
			this.createTime = date ? [...date] : '';
		},
		search() {
			this.getSaleOverview();
        },
		getSaleOverview() {
			this.api.getSaleOverview(this.searchData).then(data => {
				this.saleData = data.data.result;
				this.initEcharts();
				this.getTrend();
			})
		},
		initEcharts() {
			this.$nextTick(() => {
				this.initPie();
				this.initBar();
				this.initWorld();
			})
		},
		getTrend() {
			let searchData = {...this.searchData};
			searchData.data_type = this.data_type;
			this.api.getOverviewTrend(searchData).then(data => {
				this.trendTable = data.data.result.date || [];
				this.initTableData({page_size: this.page_size, page: 1});
				this.$nextTick(() => {
					this.initBarLine();
				})
			})
		},
		trendFilter(data) { //历史趋势统计指标选择
			if(this.trendData.indexOf(data) == -1) {
				this.trendData.push(data);
			}else{
				this.trendData.splice(this.trendData.indexOf(data), 1);
			}
		},
		initTableData(data) {
            this.trendTableData = [];
            this.page = data.page;
            this.page_size = data.page_size;
            for(let i=(data.page_size * (data.page - 1)); i<this.trendTable.length; i++) {
                this.trendTableData.push(this.trendTable[i]);
                if(this.trendTableData.length == data.page_size) break;
            }
        },
		initPie() {
			let channels_chart_data = [];
			const platformData = this.saleData.platform[this.typeSelect.value];
			const rootPlatform = this.rootData.platform_list;

			if(this.typeSelect.value == 'total_cost') {
				for(let [k, v] of Object.entries(this.saleData.fee_rate)) {
					channels_chart_data.push({name: this.costData[k], value: Math.abs(v), rVal: v});
				}
			}else{
				for(let i=0; i < rootPlatform.length; i++) {
					if(platformData.keys.indexOf(rootPlatform[i].dictItem) != -1){
						channels_chart_data.push({name: rootPlatform[i].dictItemDesc, value: Math.abs(platformData.vals[platformData.keys.indexOf(rootPlatform[i].dictItem)]), rVal: platformData.vals[platformData.keys.indexOf(rootPlatform[i].dictItem)]});
					}
				}
			}
			channels_chart_data.sort((a,b) => {
				return b.value - a.value;
			})

			let product_chart_data = [];
			const productData = this.saleData.productCategory[this.typeSelect.value];
			const rootProduct = this.rootData.product_cate_list;
			rootProduct.forEach(item => {
				if(productData.keys.indexOf(item.id) != -1){
					product_chart_data.push({name: item.dictItemDesc, value: Math.abs(productData.vals[productData.keys.indexOf(item.id)]), rVal: productData.vals[productData.keys.indexOf(item.id)]});
				}
			})
			if(productData.keys.indexOf('') != -1) {
				product_chart_data.push({name: '未分类', value: Math.abs(productData.vals[productData.keys.indexOf('')]), rVal: productData.vals[productData.keys.indexOf('')]});
			}
			product_chart_data.sort((a,b) => {
				return b.value - a.value;
			})

			var channelsChart = this.echarts.init(this.$refs.channels_chart);
			channelsChart.clear();
        	channelsChart.setOption(this.setPieOption(channels_chart_data));

			var productChart = this.echarts.init(this.$refs.product_chart);
			productChart.clear();
        	productChart.setOption(this.setPieOption(product_chart_data));
		},
		initBar() {
			const countryData = this.saleData.abbr[this.typeSelect.value];
			const rootCountry = this.rootData.country_list;
			let country_ranking_label = [];
			let country_ranking_value = [];
			let country_ranking_value2 = [];
			for(let i=0; i< rootCountry.length; i++) {
				if(countryData.keys.indexOf(rootCountry[i].abbr) != -1){
					country_ranking_label[countryData.keys.indexOf(rootCountry[i].abbr)] = rootCountry[i].chinese;
				}
				if(country_ranking_label.length == countryData.keys) break;
			}
			if(countryData.keys.indexOf('') != -1) {
				country_ranking_label[countryData.keys.indexOf('')] = '未分类';
			}
			country_ranking_value = countryData.vals;
			country_ranking_value2 = this.saleData.abbr.gross_profit_rate.vals;

			let product_ranking_label = [];
			let product_ranking_value = [];
			let product_ranking_value2 = [];
			let product_ranking_rate = [];
			const productData = this.saleData.productType[this.typeSelect.value];
			const rootProduct = this.rootData.product_type_list;
			rootProduct.forEach(item => {
				if(productData.keys.indexOf(item.id) != -1){
					product_ranking_label[productData.keys.indexOf(item.id)] = item.dictItem;
				}
			})
			if(productData.keys.indexOf('') != -1) {
				product_ranking_label[productData.keys.indexOf('')] = '未分类';
			}
			product_ranking_rate = productData.rate;
			product_ranking_value = productData.vals;
			product_ranking_value2 = this.saleData.productType.gross_profit_rate.vals;

			var countryChart = this.echarts.init(this.$refs.country_ranking_chart);
			countryChart.clear();
        	countryChart.setOption(this.setBarOption(country_ranking_label, country_ranking_value, country_ranking_value2));
			
			var productChart = this.echarts.init(this.$refs.product_ranking_chart);
			productChart.clear();
        	productChart.setOption(this.setBarOption(product_ranking_label, product_ranking_value, product_ranking_value2, product_ranking_rate));
		},
		initWorld() {
			let world_chart_data = [], vArr = [], code;
			const countryData = this.saleData.abbr;
			const rootCountry = this.rootData.country_list;
			
			for (let k=0; k<countryData[this.typeSelect.value].keys.length; k++) {
				code = countryData[this.typeSelect.value].keys[k];
				
				for(let i=0; i<rootCountry.length; i++) {
					if(rootCountry[i].abbr === code){
						world_chart_data.push({name: rootCountry[i].chinese, value: countryData[this.typeSelect.value].vals[k], 
							other: `<span style="color: #868998">销量: </span><span style="color: #2B2B35">${this.formatNumber(countryData.sale_num.vals[countryData.sale_num.keys.indexOf(code)])}</span> <br /> 
							<span style="color: #868998">销售额: </span><span style="color: #2B2B35">${this.formatNumber(countryData.sale_amount.vals[countryData.sale_amount.keys.indexOf(code)])}</span> <br /> 
							<span style="color: #868998">毛利润: </span><span style="color: #2B2B35">${this.formatNumber(countryData.gross_profit.vals[countryData.gross_profit.keys.indexOf(code)])}</span> <br /> 
							<span style="color: #868998">毛利率: </span><span style="color: #2B2B35">${countryData.gross_profit_rate.vals[countryData.gross_profit_rate.keys.indexOf(code)] ? this.formatNumber(countryData.gross_profit_rate.vals[countryData.gross_profit_rate.keys.indexOf(code)]) + '%' : '--'}</span> <br /> 
							<span style="color: #868998">总成本: </span><span style="color: #2B2B35">${this.formatNumber(countryData.total_cost.vals[countryData.total_cost.keys.indexOf(code)])}</span>`});
						break;
					}
				}
			}
			vArr = [...countryData[this.typeSelect.value].vals]
			var worldChart = this.echarts.init(this.$refs.world_chart);
        	worldChart.setOption(this.setMapOption(world_chart_data, Math.max.apply(null,vArr)));
		},
		initBarLine() {
			let date = [], sale_num = [], sale_amount = [], gross_profit = [];
			this.trendTable.forEach(item => {
				date.unshift(item.val);
				sale_num.unshift(item.sale_num || 0);
				sale_amount.unshift(item.sale_amount || 0);
				gross_profit.unshift(item.gross_profit || 0);
			})


			var trendChart = this.echarts.init(this.$refs.trend_chart);
			trendChart.clear();
        	trendChart.setOption(this.setBarLineOption(date, sale_num, sale_amount, gross_profit));
		},
        setMapOption(value, max) {
            return {
				tooltip: {
					trigger: 'item',
					borderColor: '#fff',
					formatter: (p) => {
						let str = `<span>${p.name}</span>`
						return `<span style="color:#507FF7;font-weight: 600;line-height:30px;">${p.name}</span><br />${(p.value ? p.data.other : '--')}`;
					}
				},
                visualMap: [{  // 映射-颜色值
					orient: "vertical", // 分段方向
					type: "piecewise", // 分段
					left: 20,
					bottom: 20,
					itemWidth: 12,
					itemHeight: 12,
					itemGap:20,
					selectedMode: false,
					textStyle: {
						color: '#fff'
					},
					pieces: [  // 配置颜色区间
						{lt: 0, color: "#24E09E"},
						{ min: 0, max: max/5, color: "#507FF7" },
						{ min: max/5, max: max/4, color: "#0059F0" }, 
						{ min: max/4, max: max/3, color: "#21E1FF" },
						{ min: max/3, max: max/2, color: "#FAD151" },
						{ gt: max/2, color: "#F89648" }
					]
				}],
				series: [{
					name: "世界地图",
					type: "map",  // 配置图表类型
					map: "world", // 地图
					roam: false,  // 是否允许自动缩放
					zoom: 1.1,    // 地图缩放比例
					label: {      // 配置字体
						show: false,  // 控制地图显示名字
						fontSize: 8,
					},
					itemStyle: {  // 配置地图样式
						color: '#fff',
						areaColor: 'rgba(80, 127, 247, .4)',
						borderColor: 'rgba(0,0,0,.7)',
					},
					emphasis: {// 选中的区域颜色及阴影效果等
						label: {
							color: '#000',
						},
						itemStyle: {
							
							areaColor: 'rgba(80, 127, 247, 1)',
							shadowOffsetX: 0,
							shadowOffsetY: 0,
							shadowBlur: 20,
							borderWidth: 0,
						}
					},
					select: {
						disabled: true,
						label: {
							color: '#000',
						},
						itemStyle: {
							areaColor: 'none',
						}
					},
					data:value,
					nameMap: nameMap,  //world.js   name  中英文映射关系
				}]
            };
        },
		setPieOption(data) {
			return {
				color: ['#507FF7','#46FAF8', '#24E09E', '#F8D95A', '#F4616C', '#EB534B'],
                tooltip: {
                    trigger: 'item',
					formatter: p => {
						return p.name + ': <br />' + this.formatNumber(p.data.rVal) + '(' + (p.data.rVal < 0 ? '-' : '') + p.percent + '%)'
					}
                },
                series: [
                    {
                        name: this.typeSelect.name,
                        type: 'pie',
                        radius: ['40%', '60%'],
                        avoidLabelOverlap: false,
						minShowLabelAngle: 10,
						label: {
							color: '#fff',
							width: 65,
							overflow: 'truncate',
							lineHeight: 18,
							alignTo: 'labelLine',
							formatter: p => {
								return p.name + '\n' + (p.data.rVal < 0 ? '-' : '') + p.percent + '%';
							}
						},
						labelLine: {
							length: 15,
							length2: 10,
						},
                        itemStyle: {
                            // borderRadius: 10,
                            borderColor: '#072849',
                            borderWidth: 2
                        },
                        data: data
                    }
                ]
            };
		},
		setBarOption(key, value1, value2, rate) {
			return {
				color: ['#507FF7', '#3DB8CC'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					},
					formatter: (p) => {
						let str = `${p[0].marker + p[0].seriesName}: ${p[0].value ? this.formatNumber(p[0].value) : '--'}`;
						if((this.typeSelect.name == '销量' || this.typeSelect.name == '销售额') && rate) {
							str += `<br />${p[0].marker + p[0].seriesName}占比: ${rate[p[0].dataIndex]}`
						}else{
							
						}
						if(p[1]) {
							str += `<br /> ${p[1].marker +p[1].seriesName}: ${p[1].value ? (this.formatNumber(p[1].value) + '%') : '--'}`
						}
						return str;
					}
				},
				legend: {
					show: this.typeSelect.name == '毛利润',
					left: 20,
					top: 0,
					itemWidth: 12,
					itemHeight: 12,
					itemGap: 20,
					textStyle: {
						color: '#999'
					},
					selectedMode: false,
					data: ['毛利润', '毛利率']
				},
				grid: {
					left: '10',
					right: '40',
					top: this.typeSelect.name == '毛利润' ? '30' : '10',
					bottom: '30',
					containLabel: true
				},
				xAxis: [{
					type: 'value',
					name: this.typeSelect.name,
					position: this.typeSelect.name == '毛利润' ? 'top' : 'bottom',
					splitNumber: 5,
					alignTicks: true,
					nameLocation: 'center',
					nameTextStyle: {
						lineHeight: '50'
					},
					splitLine: {
						show: false
					},
					axisLabel: {
						color: '#fff',
						formatter: function(value, index) {
                            if(Math.abs(value/1000000) >= 1) {
                                return value/1000000 + 'M';
                            }else if(Math.abs(value/1000) >= 1) {
                               return value/1000 + 'K';
                            }
                            return value;
                        }
					},
				},{
					show: this.typeSelect.name == '毛利润' && value2[0],
					type: 'value',
					name: '毛利率',
					position: 'bottom',
					splitNumber: 5,
					alignTicks: true,
					nameLocation: 'center',
					nameTextStyle: {
						lineHeight: '40'
					},
					splitLine: {
						show: false
					},
					axisLabel: {
						color: '#fff',
						formatter: function(value, index) {
                            return value + '%';
                        }
					},
				}],
				yAxis: [{
					type: 'category',
					inverse: true,
					axisTick: {
						show: false
					},
					axisLabel: {
						color: '#fff'
					},
					data: key
				}],
				dataZoom: {
					type: 'slider',
					yAxisIndex: 0,
					start: 0,
                    end: 100,
					maxValueSpan: this.typeSelect.name == '毛利润' ? 6 : 10,
					width: 10,
					brushSelect: false,
					backgroundColor: 'rgba(255, 255, 255, .05)',
					borderColor: 'rgba(255, 255, 255, 0)',
					fillerColor: 'rgba(255, 255, 255, .08)',
					showDataShadow: false,
					showDetail: false
				},
				series: this.typeSelect.name == '毛利润' && value2[0] ? [{
					name: this.typeSelect.name,
					type: 'bar',
					label: {
						show: true,
						color: '#fff',
						align: 'left',
						fontSize: 10,
						formatter: (p) => {
							return this.formatNumber(p.value);
						}
					},
					data: value1
				},{
					name: '毛利率',
					type: 'bar',
					label: {
						show: true,
						color: '#fff',
						align: 'left',
						fontSize: 10,
						formatter: (p) => {
							return this.formatNumber(p.value || 0) + '%';
						}
					},
					xAxisIndex: 1,
					data: value2
					}
				] : {
					name: this.typeSelect.name,
					type: 'bar',
					label: {
						show: true,
						color: '#fff',
						align: 'left',
						fontSize: 10,
						formatter: (p) => {
							return this.formatNumber(p.value);
							
						}
					},
					data: value1
				}
			}
		},
		setBarLineOption(date, sale_num, sale_amount, gross_profit) {
			let rname;
			if(this.trendData.indexOf('sale_num') != -1 && this.trendData.indexOf('gross_profit') != -1){
				rname = '销售额/毛利润';
			}else if(this.trendData.indexOf('sale_amount') != -1){
				rname = '销售额';
			}else if(this.trendData.indexOf('gross_profit') != -1){
				rname = '毛利润';
			}
			return {
				color: ['#73EFE5', '#FAD151', '#507FF7'],
				grid: {
					left: '20',
					right: '1',
					top: '30',
					bottom: '50',
					containLabel: true
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				legend: {
					itemGap: 20,
					textStyle: {
						color: '#999'
					},
					selectedMode: false,
					inactiveColor: 'rgba(132, 133, 139,.7)',
					inactiveBorderColor: 'rgba(132, 133, 139,.7)',
					selected: {
						'销售额': this.trendData.indexOf('sale_amount') != -1,
						'毛利润': this.trendData.indexOf('gross_profit') != -1,
						'销量': this.trendData.indexOf('sale_num') != -1
					},
					data: ['销售额', '毛利润', '销量']
				},
				xAxis: [
					{
					type: 'category',
					axisTick: {
						alignWithLabel: true
					},
					splitLine: {
						show: false
					},
					axisLine: {
						onZeroAxisIndex: 1,
					},
					axisLabel: {
                        formatter: (item) => {
                            if(this.$store.state.type == 'pc') {
                                return item.split('~')[item.split('~').length - 1];
                            }else{
                                return item.split('~')[item.split('~').length - 1].substr(5);
                            }
                        }
                    },
					data: date
					}
				],
				yAxis: [{
					type: 'value',
					name: rname,
					alignTicks: true,
					nameTextStyle: {
						align: 'left'
					},
					axisLine: {
						show: true,
					},
					splitLine: {
						show: false
					},
					axisTick: {
						show: true
					},
					axisLabel: {
						formatter: function(value, index) {
                            if(Math.abs(value/1000000) >= 1) {
                                return value/1000000 + 'M';
                            }else if(Math.abs(value/1000) >= 1) {
                               return value/1000 + 'K';
                            }
                            return value;
                        }
					}
				},{
					type: 'value',
					name: this.trendData.indexOf('sale_num') != -1 ? '销量' : '',
					alignTicks: true,
					nameTextStyle: {
						align: 'right'
					},
					axisLine: {
						show: true,
					},
					axisLabel: {
						formatter: function(value, index) {
                            if(Math.abs(value/1000000) >= 1) {
                                return value/1000000 + 'M';
                            }else if(Math.abs(value/1000) >= 1) {
                               return value/1000 + 'K';
                            }
                            return value;
                        }
					},
					axisTick: {
						show: true
					},
					splitLine: {
						show: false
					}
				}],
				dataZoom: {
                    type: 'slider',
                    start: 0,
                    end: 100,
					height: 16,
					maxValueSpan: this.trendData.indexOf('sale_num') != -1 ? 40 : date.length,
					brushSelect: false,
					showDataShadow: false,
					showDetail: false,
					backgroundColor: 'rgba(255, 255, 255, .05)',
					fillerColor: 'rgba(255, 255, 255, .05)',
					borderColor: 'rgba(255,255,255,.1)',
					handleStyle: {
						borderWidth: 2
					}
                },
				series: [{
					name: '销售额',
					type: 'line',
					smooth: true,
					symbol: 'none',
					yAxisIndex: 0,
					data: sale_amount
				},{
					name: '毛利润',
					type: 'line',
					smooth: true,
					symbol: 'none',
					yAxisIndex: 0,
					data: gross_profit
				},{
					name: '销量',
					type: 'bar',
					yAxisIndex: 1,
					barWidth: 20,
					data: sale_num
				}]
			};
		}
    }
})
</script>
<style lang="less" scoped>
	.tip{
		font-size: 14px;
		line-height: 2;
	}
	
    .sales-operation{
		padding: 0;
		background: #00172E;
		color: #fff;
		overflow: hidden;
		.flexLayout(flex-start, flex-start);
		flex-direction: column;
		.bg{
			background: #072849;
		}
		& > div {
			padding: 20px 20px 10px;
		}
		.search_box{
			width: 100%;
			box-sizing: border-box;
			.title{
				position: relative;
				.fullscreen{
					position: absolute;
					top: 0;
					right: 20px;
					cursor: pointer;
				}
			}
			/deep/.search-form{
				margin-top: 20px;
				@selectColor: #203D5B;
				.el-select__tags{
					flex-wrap: nowrap;
					overflow: hidden;
				}
				.el-tag.el-tag--info{
					background: @selectColor;
					border: @selectColor;
					.el-tag__close{
						background-color: rgba(255,255,255,.1);
						color: #868998;
					}
				}
				.el-select-dropdown{
					border-color: @selectColor;
					background-color: @selectColor;
					
					&.is-multiple{
						.el-select-dropdown__item.selected{
							background-color: rgba(255,255,255,.1);
						}
					}
					.el-scrollbar__wrap--hidden-default{
						margin-bottom: -10px;
						margin-right: -10px;
					}
					.el-select-dropdown__item{
						color: #fff;
					}
					.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
						background-color: rgba(255,255,255,.1);
					}
				}
				.el-popper[x-placement^=bottom] .popper__arrow{
					border-bottom-color: @selectColor;
					&::after{
						border-bottom-color: @selectColor;
					}
				}
				.el-form-item{
					margin: 0 5px 10px 0;
				}
				.el-input__inner{
					background: none;
					border-color: rgba(232, 233, 241, .3)!important;
					border-radius: 4px!important;
					color: #fff;
					width: 180px;
					&::-webkit-input-placeholder{
						color:#868998;
					}
				}
				.el-input.is-focus{
					.el-input__inner{
						border-color: rgba(232, 233, 241, 0.3)!important;
					}
				}
				.el-date-editor{
					.el-range-input{
						background: none;
						color: #fff;
						&::-webkit-input-placeholder{
							color:#868998;
						}
					}
					.el-range-separator{
						color: #999;
					}
				}
				.date_box{
					background: none;
					border-radius: 4px!important;
					border-color: rgba(232, 233, 241, .3);
					color: #fff;
				}
				.white{
					background: none;
					color: #D1D1D1;
				}
			}
		}
		/deep/ .main_content{
			width: 100%;
			box-sizing: border-box;
			overflow: hidden;
			flex: 1;
			padding: 0 10px 20px 0;
			padding-right: 10px;
			.area{
				width: 100%;
				height: 100%;
				padding: 0 10px 0 20px;
				box-sizing: border-box;
				overflow:auto;
			}
			.sales_data{
				.data_item{
					border-radius: 12px;
					padding: 30px 10px 15px 20px;
					cursor: pointer;
					.flexLayout(flex-start,flex-start);
					flex-wrap: nowrap;
					.ico{
						img{
							width: 56px;
							margin-top: 10px;
						}
					}
					.number_box{
						margin-left: 20px;
						min-width: 190px;
						.number{
							margin-top: 12px;
							font-size: 18px;
							font-weight: 600;
						}
						.ratio{
							font-size: 12px;
							.flexLayout(flex-start, center);
							flex-wrap: nowrap;
							.ratio_box{
								.flexLayout(flex-start, center);
								flex-wrap: nowrap;
								.ratio_num{
									padding-left: 3px;
									&.ratio_num_down{
										color: #00D6B9;
									}
									&.ratio_num_up{
										color: #EB534B;
									}
								}
								img{
									margin-left: 3px;
									margin-top: 1px;
									width: 8px;
								}
							}
							
							.rate{
								padding-left: 10px;
							}
						}
					}
					&.select{
						background: @colorBlue2;
					}
					@media (max-width: 1370px) {
						padding-left: 10px;
						.ico{
							img{
								width: 50px;
							}
						}
						.number_box{
							margin-left: 12px;
							.number {
								font-size: 16px;
							}
						}
					}
				}
			}
			.chart_area{
				margin: 10px 0 30px;
				.flexLayout(space-between, flex-start);
				flex-wrap: nowrap;
				.chart_left, .chart_right{
					width: 360px;
				}
				.chart_center{
					flex: 1;
					margin: 0 10px;
				}
				.chart_type_1{
					height: 360px;
					.echarts_box{
						height: 300px;
					}
				}
				.chart_type_2{
					height: 730px;
					.echarts_box{
						height: 650px;
					}
				}
				.margin-b{
					margin-bottom: 10px;
				}
				.chart_box{
					padding: 20px 0 0;
					background: #072849;
					border-radius: 12px;
					height: 100%;
					box-sizing: border-box;
					.subtitle{
						padding-left: 20px;
						font-size: 14px;
						margin-bottom: 20px;
						.flexLayout(flex-start);
						&::before{
							content: '';
							display: inline-block;
							width: 2px;
							height: 12px;
							background: @colorBlue2;
							margin-right: 6px;
						}
						&.subtitle2{
							margin-bottom: 10px;
						}
					}
					.echarts_box{
						width: 100%;
						.chart{
							width: 100%;
							height: 100%;
						}
					}
				}
			}
			.trend{
				margin-bottom: 30px;
				.filter{
					margin: 20px 0;
					.el-form-item__label{
						color: #868998;
					}
					.filter_box{
						.flexLayout(space-between);
						.filter_item{
							.flexLayout(flex-start);
							.filter_data{
								width: 118px;
								line-height: 32px;
								border: 1px solid #858999;
								border-radius: 4px;
								text-align: center;
								color: #858999;
								margin: 0 10px;
								cursor: pointer;
								&.select{
									border-color: @colorBlue2;
									background: @colorBlue2;
									color: @colorWhite;
								}
							}
						}
						.select_show_type{
							.el-radio-button__inner{
								padding: 9px 20px;
								border-color: #858999;
								color: #858999;
								background: none;
							}
							.el-radio-button__orig-radio:checked+.el-radio-button__inner{
								border-color: @colorBlue2;
								background: @colorBlue2;
								color: @colorWhite;
							}
						}
					}
				}
				.chart_box{
					width: 100%;
					height: 320px;
					.trend_chart{
						width: 100%;
						height: 100%;
					}
				}
			}
			.trend_table{
				.el-table{
					color: #fff;
					background: none;
					thead {
						color: #fff;
						th{
							background: #072849;
						}
					}
					tr{
						background: none;
					}
					td{
						border-bottom-color: rgba(255,255,255,.15);
					}
					&.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
						background: none;
					}
					&::before{
						height: 0;
					}
				}
				.el-pager li{
					background: none!important;
				}
				.el-pagination__jump,.el-pagination__total{
					color: #858999;
				}
				.el-input__inner{
					background: none;
					border-color: rgba(232, 233, 241, 0.3) !important;
					color: #858999;
				}
				.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
					background-color: #072849;
    				color: #eee;
				}
			}
			& ::-webkit-scrollbar-track{
				border-radius: 5px;
			}
			& ::-webkit-scrollbar-track-piece {
				/*滚动条凹槽的颜色*/
				background: rgba(255,255,255,.05);
			}
			& ::-webkit-scrollbar {
				/* 滚动条的宽度*/
				width: 8px;
			}
			& ::-webkit-scrollbar-thumb {
				/*滚动条的设置*/
				background-color: #264360;
			}
			& ::-webkit-scrollbar-thumb:hover {
				background-color: #264360;  
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/statistics/sales/overview.vue